module.exports = __webpack_public_path__ + "media/src/images/my-transactions-128-4a85cb9efa80dab5a1ad4d50c4a13602.png";